<form [formGroup]="requirementForm" (ngSubmit)="save()">
  <mat-card appearance="outlined">
    <mat-card-content>
      <div class="flex-row flex-col-ltmd gap-col-1em">
        <div class="sub-title">
          <h4>Uppfyllda krav: {{fulfilledRequirementCount }} av {{ requirementCount }} </h4>
        </div>
      </div>
      <div class="flex-row flex-col-ltmd gap-col-1em">
        @if (loadingIndicator) {
          <mat-progress-bar mode="query"></mat-progress-bar>
        }

        <div formArrayName="requirements">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="flex-1 mat-header-cell left">Namn</th>
                <th class="flex-2 mat-header-cell left">Beskrivning</th>
                <th class="flex-1 mat-header-cell left">Uppfyllt</th>
                <th class="flex-1 mat-header-cell left">Uppfyllt i tidigare rapport</th>
              </tr>
            </thead>
            <tbody>
              @for (requirement of requirementsArray.controls; track requirement; let idx = $index) {
                <tr class="mat-row" [formGroupName]="idx">
                  <td class="flex-1 mat-cell">{{ requirement.get("name").value }}</td>
                  <td class="flex-2 mat-cell">{{ requirement.get("description").value }}</td>
                  <td class="flex-1 mat-cell"><mat-checkbox formControlName="fulfilled" (change)="fulFilledChanged($event)" ></mat-checkbox></td>
                  <td class="flex-1 mat-cell"><mat-checkbox formControlName="previousFulfilled" [disabled]="true"></mat-checkbox></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <section class="button-container">
        @if (hasPermissionToChange$ | async) {
          <button type="submit" mat-fab color="primary" title="{{'commands.Save' | translate }}"><mat-icon>done</mat-icon></button>
        }
        <button type="button" mat-fab (click)="cancel()" color="warn" title="{{'commands.Cancel' | translate }}"><mat-icon>arrow_back</mat-icon></button>
      </section>
    </mat-card-actions>
  </mat-card>
</form>
